'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosInformatoutline = function IoIosInformatoutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.9 13.4c0-1 0.5-1.5 1.5-1.5s1.6 0.5 1.6 1.5-0.5 1.6-1.6 1.6-1.5-0.5-1.5-1.6z m3.1 13.5h1.3v0.6h-5v-0.6h1.2v-9.4h-1.2v-0.6h3.7v10z m-1.2-23.1c4.4 0 8.2 1.5 11.4 4.7s4.8 7 4.8 11.5-1.6 8.3-4.8 11.5-7 4.8-11.4 4.8-8.3-1.6-11.5-4.8-4.8-7-4.8-11.5 1.6-8.3 4.8-11.5 7-4.7 11.5-4.7z m0 31.1c4.1 0 7.6-1.5 10.5-4.4s4.4-6.4 4.4-10.5-1.5-7.7-4.4-10.5-6.4-4.4-10.5-4.4-7.7 1.5-10.6 4.4-4.4 6.4-4.4 10.5 1.5 7.7 4.4 10.5 6.4 4.4 10.6 4.4z' })
        )
    );
};

exports.default = IoIosInformatoutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-informatoutline.js
// module id = 2218
// module chunks = 0